import { Tabs, Tab, Container, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ALL_TABS = [
  { path: '/folk-saptapur', label: 'Service Tasks', permission: 'folk_saptapur.service_tasks' },
  { path: '/folk-saptapur/morning-sadhana', label: 'Morning Sadhana', permission: 'folk_saptapur.morning_sadhana' },
  { path: '/folk-saptapur/sadhana-report', label: 'Sadhana Report', permission: 'folk_saptapur.sadhana_report' },
  { path: '/folk-saptapur/assign-tasks', label: 'Assign Service Tasks', permission: 'folk_saptapur.assign_tasks' },
];

function FolkSaptapurTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const TABS = ALL_TABS.filter((t) => hasPermission(t.permission));
  const activeIndex = TABS.findIndex((tab) => tab.path === location.pathname);

  return (
    <Container maxWidth="xl" sx={{ mt: 3 }}>
      <Paper>
        <Tabs
          value={activeIndex === -1 ? 0 : activeIndex}
          onChange={(e, newValue) => navigate(TABS[newValue].path)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map((tab) => (
            <Tab key={tab.path} label={tab.label} />
          ))}
        </Tabs>
      </Paper>
    </Container>
  );
}

export default FolkSaptapurTabs;
